import React from "react";
import styled from "styled-components";

const TextStyle = styled.label`
  color: #1d2939;
  font-size: 14px;
  font-style: normal;
  font-weight: ${(props) => (props.isValue ? 500 : 600)};
  margin: 0px;
  padding-bottom: 0px !important;
  line-height: 20px;
`;

function TitleText({ inputId, isValue = false, children }) {
  return (
    <label
      htmlFor="contentDetail"
      className="col-md-12 col-form-label"
    >
      {children}
    </label>
    // <TextStyle htmlFor={inputId} isValue={isValue}>
    //   {children}
    // </TextStyle>
  );
}
export default TitleText;
